import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Button from "components/CustomButtons/Button.js";
import Close from "@material-ui/icons/Close";
import classNames from "classnames";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";

const useStyles3 = makeStyles(javascriptStyles);
const useStyles2 = makeStyles(headersStyle);
const useCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

const EmailPreview = ({ emailPreview, setEmailPreview, emailPreviewData }) => {
	const classes2 = useStyles2();
	const classes3 = useStyles3();
	const classesCustomerDetailsStyles = useCustomerDetailsStyles();
	console.log(emailPreviewData, "emailPreviewData");
	return (
		<Dialog
			classes={{
				root: classes3.modalRoot,
				paper: classes3.modal + " " + classes3.createCustomerModal,
			}}
			open={emailPreview}
			TransitionComponent={Transition}
			keepMounted
			onClose={() => setEmailPreview(false)}
			aria-labelledby="classic-modal-slide-title"
			aria-describedby="classic-modal-slide-description">
			<DialogTitle
				id="classic-modal-slide-title"
				disableTypography
				className={classNames(classes3.container, classes3.modalHeader)}>
				<Button
					simple
					className={classes3.modalCloseButton}
					key="close"
					aria-label="Close"
					onClick={() => setEmailPreview(false)}>
					{" "}
					<Close className={classes3.modalClose} />
				</Button>
				<h4 className={classNames(classes3.modalTitle)}>Email Preview</h4>
			</DialogTitle>
			<DialogContent
				id="classic-modal-slide-description"
				className={classes3.modalBody}>
				<hr />

				<GridContainer>
					<GridItem
						xs={12}
						sm={12}
						md={12}
						className={classNames(
							classes2.customInputAdd,
							classesCustomerDetailsStyles.mT20
						)}>
						<div dangerouslySetInnerHTML={{ __html: emailPreviewData?.html }}></div>
					</GridItem>
				</GridContainer>
			</DialogContent>
			<DialogActions className={classes3.modalFooter}></DialogActions>
		</Dialog>
	);
};

export default EmailPreview;
